import '@/styles/supervise.scss';
import React from 'react';
import { Button } from 'antd-mobile';

const Screenshot = (props) => {
  const { player, handleSnapshot } = props;
  const snapshoted = () => {
    if (player) {
      player.play();
      const video = player.tag;
      if (!player) {
        return;
      }
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth; //视频原有尺寸
      canvas.height = video.videoHeight; //视频原有尺寸
      var ctx = canvas.getContext('2d');
      var image = player.getImage();
      if (image === 'vertical') {
        //垂直镜像
        ctx.translate(0, canvas.height);
        ctx.scale(1, -1);
      } else if (image === 'horizon') {
        //水平镜像
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
      }
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const base64 = canvas.toDataURL('image/png', 1.0);
      handleSnapshot && handleSnapshot(base64, canvas);
    }
  };

  return <Button className="supervise-screenshot" onClick={snapshoted}></Button>;
};

export default Screenshot;
